const PURCHASE_URL = process.env.REACT_APP_PURCHASE_URL || "#pricing";
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const WHATSAPP = process.env.REACT_APP_WHATSAPP || "";
const PLAYSTORE_URL = process.env.REACT_APP_PLAYSTORE_URL || "#";
const APPSTORE_URL = process.env.REACT_APP_APPSTORE_URL || "#";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://prop.dhokiyas.ae";

export const CONFIG = {
  PRODUCT_NAME: "Dhokiya's Prop Passer Gold EA",
  PURCHASE_URL,
  PIXEL_ID,
  WHATSAPP,
  PLAYSTORE_URL,
  APPSTORE_URL,
  SITE_URL,
  COPIES_LEFT: 23,
  COUNTDOWN_MINUTES: 14 * 60,
  SELLER: "Dhokiya's Research Analyst (OPC) Private Limited",
  GUARANTEE_DAYS: 14,
  RATING: 4.8,
  REVIEW_COUNT: 127,
  BUYERS: "1,000+",
  MAX_ACCOUNTS: 10,
};

// Multi-provider tracking — fires the same event across every loaded pixel.
// Resilient to ad-blockers / Meta financial-services restrictions.
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  // GTM dataLayer (universal — works for all GTM-based stacks)
  if (window.dataLayer) window.dataLayer.push({ event: eventName, ...params });
  // GA4 / Google Ads via gtag
  if (typeof window.gtag === "function") window.gtag("event", eventName, params);
  // Meta Pixel
  if (typeof window.fbq === "function") {
    const META_MAP = {
      page_view: "PageView",
      view_content: "ViewContent",
      initiate_checkout: "InitiateCheckout",
      lead: "Lead",
      add_to_cart: "AddToCart",
      purchase: "Purchase",
    };
    const metaEv = META_MAP[eventName] || eventName;
    window.fbq("track", metaEv, params);
  }
  // TikTok Pixel
  if (window.ttq && typeof window.ttq.track === "function") {
    const TT_MAP = {
      page_view: "Pageview",
      view_content: "ViewContent",
      initiate_checkout: "InitiateCheckout",
      lead: "SubmitForm",
      add_to_cart: "AddToCart",
      purchase: "PlaceAnOrder",
    };
    window.ttq.track(TT_MAP[eventName] || eventName, params);
  }
};

export const goToCheckout = (currencyCode = "USD", value = 50) => {
  trackEvent("initiate_checkout", {
    currency: currencyCode,
    value,
    num_items: 1,
    content_ids: ["PPG-EA-V123"],
    content_type: "product",
    content_name: "Dhokiya's Prop Passer Gold EA",
  });
  if (typeof window === "undefined") return;
  const apiBase = process.env.REACT_APP_BACKEND_URL || "";
  fetch(`${apiBase}/api/payments/geo`, { cache: "no-store" })
    .then((r) => (r.ok ? r.json() : Promise.reject()))
    .then((geo) => {
      if (geo?.is_india) {
        // Dispatch event — Pricing.jsx mounts the embedded Cashfree modal
        window.dispatchEvent(new CustomEvent("dppg:open-cashfree", { detail: {} }));
        return;
      }
      window.open(geo?.tagmango_url || CONFIG.PURCHASE_URL, "_blank", "noopener");
    })
    .catch(() => {
      window.open(CONFIG.PURCHASE_URL, "_blank", "noopener");
    });
};

export const trackViewContent = (currencyCode = "USD", value = 50) => {
  trackEvent("view_content", {
    currency: currencyCode,
    value,
    content_ids: ["PPG-EA-V123"],
    content_type: "product",
    content_name: "Dhokiya's Prop Passer Gold EA",
  });
};

export const whatsappUrl = (msg = "Hi, I need setup help for Prop Passer Gold EA.") =>
  CONFIG.WHATSAPP ? `https://wa.me/${CONFIG.WHATSAPP}?text=${encodeURIComponent(msg)}` : "#";

// Backward-compat alias used by old imports
export const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") window.fbq(...args);
};
